class SearchDropdown extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['trigger', 'dropdown']
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onMainClick = this.onMainClick.bind(this)
    this.onMobileChange = this.onMobileChange.bind(this)

    const mainElement = document.querySelector('main')

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
    this.listeners.add(mainElement, 'click', this.onMainClick)

    if (this.els?.mobileinput?.element) {
      this.els.mobileinput.element.addEventListener(
        'keydown',
        this.onMobileChange,
      )
    }

    if (this.els?.cancel?.element) {
      this.onCancelClick = this.onCancelClick.bind(this)

      this.listeners.add(this.els.cancel.element, 'click', this.onCancelClick)
    }
  }

  onTriggerClick () {
    this.isActive = !this.isActive
  }

  onCancelClick () {
    this.isActive = false
    this.externalEls.input.element.value = ''
  }

  onMobileChange () {
    const newValue = this.els.mobileinput.element.value
    const searchInput = document?.querySelector(
      '[data-tagalys-search-el="search"]',
    )
    if (searchInput) {
      searchInput.value = newValue
    }
  }

  onMainClick (event) {
    if (event.target.closest(this.localName)) return
    if (event.target.closest('tagalys-search')) return
    if (!this.isActive) return

    this.isActive = false
  }

  get isActive () {
    return this.hasAttribute('active')
  }

  set isActive (val) {
    val ? this.setAttribute('active', '') : this.removeAttribute('active')

    val
      ? document.body.classList.add('util-SiteOverflowed', 'util-TagalysActive')
      : document.body.classList.remove(
        'util-SiteOverflowed',
        'util-TagalysActive',
      )

    window.setTimeout(() => this.externalEls.input.element.focus(), 150)
  }
}

if (!customElements.get('search-dropdown')) {
  customElements.define('search-dropdown', SearchDropdown)
}
